import request from '@/utils/request'
const BASE_URL = '/OrderMain'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  sendOrderList(data) {
    return request({
      url: BASE_URL + '/SendOrderList',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  getOrderInfo(id) {
    return request({
      url: BASE_URL + '/GetOrderInfo',
      method: 'get',
      params: { id }
    })
  },
  getOrderLogistics(id) {
    return request({
      url: BASE_URL + '/GetOrderLogistics',
      method: 'get',
      params: { id }
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  //结算
  settle(data) {
    return request({
      url: BASE_URL + '/Settle',
      method: 'post',
      data
    })
  },
  //提交
  submit(operId) {
    return request({
      url: BASE_URL + '/Submit',
      method: 'get',
      params: { operId }
    })
  },
  //提交2
  submitV2(data) {
    return request({
      url: BASE_URL + '/SubmitV2',
      method: 'post',
      data
    })
  },
  //取消
  cancel(data) {
    return request({
      url: BASE_URL + '/Cancel',
      method: 'post',
      data
    })
  },
  //申请退款
  applyRefund(data) {
    return request({
      url: BASE_URL + '/ApplyRefund',
      method: 'post',
      data
    })
  },
  //同意退款
  passRefund(data) {
    return request({
      url: BASE_URL + '/PassRefund',
      method: 'post',
      data
    })
  },
  //拒绝退款
  refuseRefund(data) {
    return request({
      url: BASE_URL + '/RefuseRefund',
      method: 'post',
      data
    })
  },
  //发货
  send(data) {
    return request({
      url: BASE_URL + '/Send',
      method: 'post',
      data
    })
  },
  //发货
  sendV2(data) {
    return request({
      url: BASE_URL + '/SendV2',
      method: 'post',
      data
    })
  },
  //获取发货单
  getDeliverDocList(orderId) {
    return request({
      url: BASE_URL + '/GetDeliverDocList',
      method: 'get',
      params: { orderId }
    })
  },
  //退货
  back(data) {
    return request({
      url: BASE_URL + '/Back',
      method: 'post',
      data
    })
  },
  //商家收货后，同意退款
  backPass(orderMainId) {
    return request({
      url: BASE_URL + '/BackPass',
      method: 'get',
      params: { orderMainId }
    })
  },
  //客户收货
  receive(orderId) {
    return request({
      url: BASE_URL + '/Receive',
      method: 'get',
      params: { orderId }
    })
  },
  //获取我的订单列表
  getMyOrderList(data) {
    return request({
      url: BASE_URL + '/GetMyOrderList',
      method: 'post',
      data
    })
  },
  //获取我的订单信息
  getMyOrderInfo(id) {
    return request({
      url: BASE_URL + '/GetMyOrderInfo',
      method: 'get',
      params: { id }
    })
  },
  //获取订单优惠券
  getMyCoupon(data) {
    return request({
      url: BASE_URL + '/GetMyCoupon',
      method: 'post',
      data
    })
  },
  //根据id获取发货订单
  getSendOrder(Ids) {
    return request({
      url: BASE_URL + '/GetSendOrder',
      method: 'get',
      params: { Ids }
    })
  },
  //获取待商品订单列表
  orderList(data) {
    return request({
      url: BASE_URL + '/OrderList',
      method: 'post',
      data
    })
  },
}